(() => {
  const root = document.querySelector('[data-fenza-faq]');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = 'true';

  const data = JSON.parse(root.querySelector('[data-faq-content]').textContent);
  const returnsSource = root.querySelector('[data-returns-source]');
  const returnsItem = data.shopping?.items?.find(entry => entry.id === 'returns');
  const editorSource = root.querySelector('[data-faq-editor-content]');
  if (editorSource) {
    const editorEntries = JSON.parse(editorSource.textContent || '[]');
    Object.values(data).forEach(categoryEntry => {
      categoryEntry.items.forEach(itemEntry => {
        const replacement = editorEntries.find(entry => entry.target === itemEntry.id);
        if (replacement) {
          if (replacement.label) itemEntry.label = replacement.label;
          const questions = (replacement.questions || []).filter(entry => entry[0]);
          if (questions.length) itemEntry.questions = questions;
        }
      });
    });
  }
  if (returnsSource && returnsItem) {
    const legalReturnsTitle = 'Yasal İade Koşulları';
    const hasLegalReturns = returnsItem.questions.some(question => question[0] === legalReturnsTitle);
    if (!hasLegalReturns) returnsItem.questions.splice(1, 0, [legalReturnsTitle, returnsSource.innerHTML]);
  }
  const home = root.querySelector('[data-faq-home]');
  const detail = root.querySelector('[data-faq-detail]');
  const quick = root.querySelector('[data-quicklinks]');
  const categories = root.querySelector('.fenza-faq__categories');
  const sidebar = root.querySelector('[data-faq-sidebar]');
  const answers = root.querySelector('[data-faq-answers]');
  const initial = root.querySelector('[data-faq-initial]');
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const duration = reduceMotion ? 0 : 360;

  const icon = type => type === 'letter'
    ? '<span class="fenza-faq__icon fenza-faq__icon--letter">F</span>'
    : `<span class="fenza-faq__icon"><svg viewBox="0 0 32 32" aria-hidden="true">${type === 'bag'
      ? '<path d="M8.5 11.5h15l1.2 15H7.3l1.2-15Z"/><path d="M12 12V9a4 4 0 0 1 8 0v3"/>'
      : type === 'cube'
        ? '<path d="m16 4 10 5.5v12L16 27 6 21.5v-12L16 4Z"/><path d="m6 9.5 10 5.5 10-5.5M16 15v12"/>'
        : '<circle cx="16" cy="10" r="5"/><path d="M7.5 27c.8-6 4-9 8.5-9s7.7 3 8.5 9"/>'}</svg></span>`;

  let category = 'shopping';
  let item = 'browsing';
  let quickOpen = true;

  function animatePanel(element, open) {
    if (window.matchMedia('(max-width: 989px)').matches) {
      element.style.removeProperty('height');
      element.style.removeProperty('opacity');
      element.style.removeProperty('overflow');
      element.style.removeProperty('transition');
      return;
    }
    element.style.overflow = 'hidden';
    const from = open ? 0 : element.scrollHeight;
    const to = open ? element.scrollHeight : 0;
    element.style.height = `${from}px`;
    element.style.opacity = open ? '0' : '1';
    element.offsetHeight;
    element.style.transition = `height ${duration}ms cubic-bezier(.4,0,.2,1), opacity ${Math.max(180, duration - 80)}ms ease`;
    element.style.height = `${to}px`;
    element.style.opacity = open ? '1' : '0';
    window.setTimeout(() => {
      element.style.transition = '';
      element.style.overflow = '';
      element.style.height = open ? 'auto' : '0px';
    }, duration + 30);
  }

  function setQuick(id, toggle = false) {
    if (toggle && id === category) quickOpen = !quickOpen;
    else quickOpen = true;
    category = id;
    root.querySelectorAll('[data-category]').forEach(button => {
      const selected = button.dataset.category === id;
      button.setAttribute('aria-selected', String(selected));
      button.setAttribute('aria-expanded', String(selected && quickOpen));
    });
    quick.innerHTML = data[id].items.map(entry => `<button type="button" data-open="${id}:${entry.id}">${entry.label}</button>`).join('');
    placeMobileQuickLinks();
    quick.classList.toggle('is-collapsed', !quickOpen);
    animatePanel(quick, quickOpen);
  }

  function placeMobileQuickLinks() {
    if (!categories || !quick) return;
    const mobile = window.matchMedia('(max-width: 989px)').matches;
    const desiredOrder = mobile
      ? ['shopping', 'account', 'products', 'fenza']
      : ['shopping', 'products', 'fenza', 'account'];
    desiredOrder.forEach(key => {
      const button = categories.querySelector(`:scope > button[data-category="${key}"]`);
      if (button) categories.appendChild(button);
    });
    const buttons = [...categories.querySelectorAll(':scope > button')];
    if (mobile) {
      const selectedIndex = Math.max(0, buttons.findIndex(button => button.dataset.category === category));
      const rowEnd = Math.min(buttons.length, Math.ceil((selectedIndex + 1) / 2) * 2);
      const nextButton = buttons[rowEnd];
      if (nextButton) categories.insertBefore(quick, nextButton);
      else categories.appendChild(quick);
    } else if (quick.parentElement === categories) {
      categories.insertAdjacentElement('afterend', quick);
    }
  }

  window.addEventListener('resize', placeMobileQuickLinks, { passive: true });

  function renderSidebar() {
    sidebar.innerHTML = Object.entries(data).map(([key, cat]) => `<section class="fenza-faq__side-category ${key === category ? 'is-open' : ''}" data-side-category="${key}"><button type="button" aria-expanded="${key === category}">${icon(cat.icon)}<span class="fenza-faq__sidebar-title">${cat.label}</span><i aria-hidden="true"></i></button><div class="fenza-faq__side-items">${cat.items.map(entry => `<button type="button" data-open="${key}:${entry.id}" class="${key === category && entry.id === item ? 'is-active' : ''}">${entry.label}</button>`).join('')}</div></section>`).join('');
  }

  function bindAccordions(scope) {
    scope.querySelectorAll('details').forEach(details => {
      const summary = details.querySelector('summary');
      const content = details.querySelector(':scope > div');
      summary.setAttribute('aria-expanded', String(details.open));
      summary.addEventListener('click', event => {
        event.preventDefault();
        const opening = !details.open;
        summary.setAttribute('aria-expanded', String(opening));
        if (opening) {
          details.open = true;
          content.animate(
            [{ height: '0px', opacity: 0, transform: 'translateY(-5px)' }, { height: `${content.scrollHeight}px`, opacity: 1, transform: 'translateY(0)' }],
            { duration, easing: 'cubic-bezier(.4,0,.2,1)' }
          );
        } else {
          const animation = content.animate(
            [{ height: `${content.offsetHeight}px`, opacity: 1, transform: 'translateY(0)' }, { height: '0px', opacity: 0, transform: 'translateY(-5px)' }],
            { duration, easing: 'cubic-bezier(.4,0,.2,1)' }
          );
          animation.onfinish = () => { details.open = false; };
        }
      });
    });
  }

  function showAnswers(animate = true, updateHistory = true) {
    const current = data[category].items.find(entry => entry.id === item) || data[category].items[0];
    item = current.id;
    const update = () => {
      answers.innerHTML = `<h1>${current.label.toLocaleUpperCase('tr-TR')}</h1><div class="fenza-faq__accordion">${current.questions.map((question, index) => `<details ${index === 0 ? 'open' : ''}><summary aria-expanded="${index === 0}">${question[0]}</summary><div>${question[1]}</div></details>`).join('')}</div>`;
      bindAccordions(answers);
      renderSidebar();
      answers.classList.remove('is-changing');
    };
    if (animate && !reduceMotion && answers.innerHTML) {
      answers.classList.add('is-changing');
      window.setTimeout(update, 150);
    } else update();
    home.hidden = true;
    detail.hidden = false;
    detail.classList.remove('is-entering');
    detail.offsetHeight;
    detail.classList.add('is-entering');
    if (updateHistory) history.replaceState(null, '', `#${category}/${item}`);
    window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
  }

  function open(value) {
    [category, item] = value.split(':');
    showAnswers();
  }

  root.addEventListener('click', event => {
    const categoryButton = event.target.closest('[data-category]');
    if (categoryButton) {
      setQuick(categoryButton.dataset.category, true);
      return;
    }
    const opener = event.target.closest('[data-open]');
    if (opener) {
      open(opener.dataset.open);
      return;
    }
    const sideButton = event.target.closest('[data-side-category] > button');
    if (sideButton) {
      const section = sideButton.parentElement;
      const wasOpen = section.classList.contains('is-open');
      sidebar.querySelectorAll('[data-side-category]').forEach(entry => {
        entry.classList.remove('is-open');
        entry.querySelector(':scope > button').setAttribute('aria-expanded', 'false');
      });
      if (!wasOpen) {
        section.classList.add('is-open');
        sideButton.setAttribute('aria-expanded', 'true');
      }
      return;
    }
    if (event.target.closest('[data-faq-back]')) {
      detail.classList.add('is-leaving');
      window.setTimeout(() => {
        detail.hidden = true;
        detail.classList.remove('is-leaving', 'is-entering');
        home.hidden = false;
        home.classList.add('is-entering');
        window.setTimeout(() => home.classList.remove('is-entering'), duration);
      }, Math.min(duration, 260));
      history.replaceState(null, '', location.pathname);
      window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
    }
  });

  bindAccordions(home);
  setQuick(category);
  const hash = location.hash.slice(1).split('/');
  if (data[hash[0]] && data[hash[0]].items.some(entry => entry.id === hash[1])) {
    category = hash[0];
    item = hash[1];
    showAnswers(false);
  } else if (initial && data[initial.dataset.category] && data[initial.dataset.category].items.some(entry => entry.id === initial.dataset.item)) {
    category = initial.dataset.category;
    item = initial.dataset.item;
    showAnswers(false, false);
  }
})();
